import { changePage, getPaymentsHistory } from 'feature/payments/paymentsSlice';
import { Fragment, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useDevice from 'hooks/DesktopDevice.hook';
import { AppDispatch, RootState } from 'store/store';
import { Collections } from 'types/Form';
import Payments from './Payments.component';
import PaymentsFooter from './PaymentsFooter.component';

const ViewPayments = () => {
	const { isDesktop } = useDevice();
	const dispatch = useDispatch<AppDispatch>();
	const { page } = useSelector((store: RootState) => store.payments);

	const {
		inputDateOfService,
		inputPaymentRunId,
		inputTotalAmount,
		sortingFields,
		sortingDirections,
		collection,
	} = useSelector((store: RootState) => store.form);

	const searchParams = useMemo(
		() => ({
			inputPaymentRunId,
			inputTotalAmount,
			inputDateOfService,
			sortingDirections,
			sortingFields,
		}),
		[
			inputPaymentRunId,
			inputTotalAmount,
			inputDateOfService,
			sortingDirections,
			sortingFields,
		],
	);

	useEffect(() => {
		if (searchParams && collection === Collections.PAYMENTS && page)
			dispatch(
				getPaymentsHistory({
					showloader: true,
					limit: '8',
				}),
			);
	}, [dispatch, isDesktop, page, searchParams, collection]);

	useEffect(() => {
		if (searchParams) dispatch(changePage(1));
	}, [dispatch, searchParams]);

	return (
		<Fragment>
			<Payments />
			<PaymentsFooter />
		</Fragment>
	);
};

export default ViewPayments;
